export const CHECKOUT_URL = "https://mastopexy-en.impultienda.ar/checkout/";

export const images = {
  mockup: "https://cdn.magicpatterns.com/uploads/ccq5oujqgemzJL9BmUgeZk/MASTOPEXY-EN.png",
  author: "https://cdn.magicpatterns.com/uploads/fKCDEGyQ7DYyrFMHqbixqi/MICHAEL_CARTER_-_IMPLANTES.png",
};
